module.exports = __webpack_public_path__ + "static/media/cs_logo.519d7602.png";